import script from "./ChatView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatView.vue?vue&type=script&lang=ts&setup=true"

import "./ChatView.vue?vue&type=style&index=0&id=3aee1482&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aee1482"]])

export default __exports__